import { FC } from 'react';

import { useTranslation } from '@eneco/i18n';
import { Text } from '@eneco/sparky';

export const ASAPCardBody: FC = () => {
  const { t } = useTranslation();

  return <Text size="BodyS">{t('asap.body')}</Text>;
};
